import React from "react";
import TaskItem from "./TaskItem";

function TaskListCompact({
  tasks,
  loadingTasks,
  labelMap,
  getUserNameById,
  startEditTask,
  handleToggleTaskStatus,
  handleDeleteTask,
  onConfirmComplete,
}) {
  if (loadingTasks) return <p className="text-sm text-gray-500">Carregando…</p>;
  if (!tasks?.length)
    return (
      <p className="text-sm italic text-gray-400">Nenhuma tarefa ainda.</p>
    );

  return (
    <div className="space-y-2">
      {tasks.map((t) => {
        return (
          <TaskItem
            key={t.id}
            t={t}
            isDone={t.status === "done"}
            labelMap={labelMap}
            getUserNameById={getUserNameById}
            startEditTask={startEditTask}
            handleToggleTaskStatus={handleToggleTaskStatus}
            handleDeleteTask={handleDeleteTask}
            onConfirmComplete={onConfirmComplete}
          />
        );
      })}
    </div>
  );
}

export default React.memo(TaskListCompact);
